import * as React from 'react';
// material-ui
import { Typography, Box, styled, CardHeader, Divider, Card, CardContent, Link } from '@mui/material';

const SideBar = styled(Box)({
    position: 'sticky',
    top: '110px',
    padding: '48px 16px'
});

const StyledCard = styled(Card)(() => ({
    border: '1px solid #D6D6D6',
    borderRadius: '4px'
}));

const SectionTitle = styled(Typography)({
    fontSize: '18px',
    fontWeight: 700,
    color: '#01131B'
});

const StyledLink = styled(Link)(() => ({
    display: 'block',
    padding: '8px',
    lineHeight: '24px',
    textDecoration: 'none',
    fontSize: '16px'
}));

export default function SidebarDatabaseLink() {
    return (
        <SideBar sx={{ display: { xs: 'none', lg: 'block' } }}>
            <StyledCard>
                <CardHeader sx={{ p: '24px 16px' }} title={<SectionTitle>Search</SectionTitle>} />
                <Divider />
                <CardContent sx={{ p: '24px 16px' }}>
                    <Box>
                        <StyledLink href="/databases/arts">Arts Entertainment Database</StyledLink>
                        <StyledLink href="/databases/films">Films Classification Database</StyledLink>
                        <StyledLink href="/databases/video-games">Video Games Classification Database</StyledLink>
                        <StyledLink href="/databases/registered-content-assessors-database">
                            Registered Content Assessors Database (Films)
                        </StyledLink>
                        <StyledLink href="/databases/registered-importers-database-page">
                            Registered Importers Database (Publications)
                        </StyledLink>
                        <StyledLink href="/databases/newspaper-register-search">Newspaper Register Search</StyledLink>
                        <StyledLink href="/databases/licence-search">Telecommunications Licence Database</StyledLink>
                        <StyledLink href="/databases/equipment-search">Telecommunications Equipment Database</StyledLink>
                    </Box>
                </CardContent>
            </StyledCard>
        </SideBar>
    );
}
